/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VatClass = {
    NotSpecified: 'NotSpecified',
    NoVat: 'NoVat',
    Vat: 'Vat',
} as const;
export type VatClass = typeof VatClass[keyof typeof VatClass];

